import Collection from './generic/collection'
import { Sortable } from '@shopify/draggable'
import { setCookie } from './utils/cookie'
import { GetAttr } from './utils/getAttr'
import { FetchData } from './utils/fetchData'
import Preloader from './preloader'

export const instance = '.custom-table'

export class Table {
  els = {
    instance,
    selectAll: '[data-table-select-all]',
    instanceWrap: '[data-table-wrapper]',
    tableId: '[data-table-id]',
    table: '[data-filter-table]',
    col: '[data-col]',
    multiSelectOption: '[data-display-field]',
    tableBody: '.custom-table__body',
    draggableColumnContainer: '[data-draggable-columns]',
    tableTotalPrice: '[data-table-total]',
    checkoutBtn: '[data-table-checkout]',
    itemCheckbox: '[data-item-price]',
  }

  stateClasses = {
    draggingContainer: '.draggable-mirror',
    dragOriginalColumn: '.draggable--original',
    dragOverColumn: '.draggable--over',
    sourceDragging: '.draggable-source--is-dragging',
    draggableContainer: 'draggable-container--is-dragging'
  }

  dragOptions = {
    draggable: '.custom-table__header__title[data-col]:not([data-col=""])',
    swapAnimation: {
      duration: 200,
      easingFunction: 'ease-in-out',
      horizontal: true
    }
  }

  constructor (instance) {
    this.instance = instance
    this.instanceWrap = this.instance.closest(this.els.instanceWrap) || document
    this.draggable = null
    this.draggaingTableColumn = []
    this.tableId = this.instance.hasAttribute(GetAttr(this.els.tableId)) ? this.tableId = this.instance.getAttribute(GetAttr(this.els.tableId)) : null
    this.dragColumns = this.instance.querySelector(this.els.draggableColumnContainer)
    this.multiSelectOption = this.instance.querySelectorAll(this.els.multiSelectOption)
    this.totalPriceContainer = this.instanceWrap.querySelector(this.els.tableTotalPrice)
    this.rootCheckbox = this.instance.querySelector(this.els.selectAll)
    this.checkoutBtn = this.instanceWrap.querySelector(this.els.checkoutBtn)
    this.checkoutItems = this.instance.querySelectorAll(`${this.els.tableBody} input[type="checkbox"]`)
    this.itemsCheckbox = this.instance.querySelectorAll(this.els.itemCheckbox)
    this.checkoutItemsLength = this.checkoutItems.length
    this.checkoutItemsDynamicLength = this.checkoutItems.length
    this.totalPrice = 0

    this.initDrag()
    this.init()
    this.bindEvents()
  }

  /**
   * @param target {HTMLElement}
   */

  selectAllCheckBox ({ target }) {
    let allCheckBox = target.closest(this.els.table).querySelector(this.els.tableBody).querySelectorAll('input[type="checkbox"]')
    let checkBoxState = target.closest(this.els.selectAll).querySelector('input').checked
    this.totalPrice = 0
    if (checkBoxState) {
      this.totalPriceContainer.innerText = `$ ${this.totalPrice}`
      this.checkoutItemsDynamicLength = 0
    } else {
      const checkBoxes = this.instance.querySelectorAll(`${this.els.tableBody} [data-item-price]`)
      checkBoxes.forEach(item => {
        this.totalPrice += Number(item.dataset.itemPrice)
      })
      this.totalPriceContainer.innerText = `$ ${this.totalPrice}`
      this.checkoutItemsDynamicLength = this.checkoutItemsLength
    }

    allCheckBox.forEach(checkBox => {
      checkBoxState ? checkBox.checked = false : checkBox.checked = true
    })
    this.setCheckoutBtnState()
  }

  async checkout ({ target }) {
    const allItems = [...this.checkoutItems].filter(item => {
      return item.checked
    })

    const priceId = target.dataset.tableId
    const ajaxUrl = target.dataset.ajaxUrl
    let selectedItemsIdArray = allItems.map(item => {
      return item.id
    })
    const dataArray = {
      productIds: selectedItemsIdArray,
      priceIncreaseId: priceId
    }
    let request = await FetchData.postData({ data: dataArray }, ajaxUrl)

    Preloader.hide()
  }

  /** set table after user did checkout
   * @param checkoutSuccess {Array<String>}
   */
  setAfterCheckout (checkoutSuccess) {
    const targetNodes = this.getCheckoutNodes(checkoutSuccess)
    if (targetNodes.length) {
      const targetTable = targetNodes[0].closest(this.els.instanceWrap)
      if (targetTable && this.checkoutItems.length === targetNodes.length) {
        targetTable.remove()
      }
    }
    this.removeCheckoutNodes(targetNodes)
    this.checkoutItems = this.instance.querySelectorAll(`${this.els.tableBody} input[type="checkbox"]`)
    targetNodes.forEach(node => {
      const label = node.closest('.card-title').querySelector('label')
      this.checkoutItemsLength -= 1
      this.setTotalPrice(label, true)
      this.setRootCheckbox({ target: label }, true)
      this.setCheckoutBtnState()
    })
  }

  /**
   * @param inputCheckoutItems {Array<String>}
   * @return {Array<NodeList>}
   */

  getCheckoutNodes (inputCheckoutItems) {
    return [...this.checkoutItems].filter(item => item.checked).filter(item => {
      return inputCheckoutItems.find(inputItem => {
        return inputItem === item.id
      })
    })
  }

  /**
   * @param checkoutNodes {Array<NodeList>}
   */

  removeCheckoutNodes (checkoutNodes) {
    checkoutNodes.forEach(node => {
      node.closest('.card').remove()
    })
  }

  /**
   * @param labelPrice {HTMLElement}
   * @param removeFlag {Boolean}
   */

  setTotalPrice (labelPrice, removeFlag = false) {
    const itemPrice = labelPrice.dataset.itemPrice
    const checkbox = labelPrice.querySelector('input[type="checkbox"]')

    if (checkbox.checked && removeFlag) {
      this.totalPrice -= Number(itemPrice)
    } else if (checkbox.checked) {
      this.totalPrice -= Number(itemPrice)
    } else {
      this.totalPrice += Number(itemPrice)
    }

    this.totalPriceContainer.innerText = `$ ${this.totalPrice}`
  }

  setRootCheckbox ({ target }, dellItemFlag = false) {
    const currTarget = target.closest('[data-item-price]').querySelector('input[type="checkbox"]')
    const inputNode = this.rootCheckbox.querySelector('input')
    if (dellItemFlag && !currTarget.checked) {
      this.checkoutItemsDynamicLength()
    } else if (currTarget.checked) {
      this.checkoutItemsDynamicLength -= 1
    } else {
      this.checkoutItemsDynamicLength += 1
    }

    if (this.checkoutItemsDynamicLength === 0 || this.checkoutItemsLength === 0) {
      inputNode.checked = false
      return
    }

    if (this.checkoutItemsLength === this.checkoutItemsDynamicLength) {
      inputNode.checked = true
      return
    }

    if (this.checkoutItemsDynamicLength < this.checkoutItemsLength) {
      inputNode.checked = false
    }
  }

  setCheckoutBtnState () {
    this.checkoutBtn.disabled = this.checkoutItemsDynamicLength === 0
  }

  setDefaultTotalPrice () {
    this.totalPrice = Number(this.totalPriceContainer.innerText.split(' ')[1])
  }

  saveVisibleColumnsData (clickedItem, flag) {
    const items = clickedItem.closest('.select_custom__options').querySelectorAll('input[type="checkbox"]')
    const checkbox = clickedItem.closest(this.els.multiSelectOption).querySelector('input[type="checkbox"]')
    let visibleColumns = []
    let nameField = this.tableId ? `visibleColumns_${this.tableId}` : 'visibleColumns'
    if (flag) {
      items.forEach(item => {
        const option = item.closest(this.els.multiSelectOption)
        if (item.id !== checkbox.id && item.checked) {
          visibleColumns.push(option.getAttribute(GetAttr(this.els.multiSelectOption)))
        }
      })
    } else {
      items.forEach(item => {
        const option = item.closest(this.els.multiSelectOption)
        if (item.id === checkbox.id || item.checked) {
          visibleColumns.push(option.getAttribute(GetAttr(this.els.multiSelectOption)))
        }
      })
    }

    setCookie(nameField, visibleColumns, { expires: 432000, path: '/' })
  }

  /**
   * @param target {HTMLElement} clicked option
   */

  displayFields ({ target }) {
    let optionCheckBox = target.closest(this.els.multiSelectOption).querySelector('input[type="checkbox"]').checked
    let displayTarget = target.closest(this.els.multiSelectOption).dataset.displayField
    let searchableColumns = this.instance.querySelectorAll(`[data-col=${displayTarget}]`)
    if (optionCheckBox) {
      searchableColumns.forEach(column => {
        column.style.display = 'none'
      })
      this.saveVisibleColumnsData(target, true)
      return false
    }

    searchableColumns.forEach(column => {
      column.style.display = 'flex'
    })
    this.saveVisibleColumnsData(target, false)
  }

  initDrag () {
    if (document.documentElement.clientWidth > 1200 && this.dragColumns) {
      this.draggable = new Sortable(this.dragColumns, this.dragOptions)
    }
  }

  drag (e) {
    const { oldIndex, newIndex } = e.data
    const rows = this.instance.querySelectorAll('.custom-table__body .custom-table__card--titles')
    rows.forEach(row => {
      const cells = row.querySelectorAll(':scope > .custom-table__card--title[data-col]:not([data-col=""])')
      if (newIndex > oldIndex) {

        cells[oldIndex].parentNode.insertBefore(cells[oldIndex], cells[newIndex].nextSibling)
      } else {
        cells[oldIndex].parentNode.insertBefore(cells[oldIndex], cells[newIndex])
      }

    })
  }

  /**
   * create or clear addition mirror container
   * @param dragStartEvent {Object}
   */

  setDraggingTableColumns (dragStartEvent) {
    if (!dragStartEvent) {
      this.draggaingTableColumn = []
      document.querySelector('.custom-drag-container').remove()
      return false
    }
    let targetData = dragStartEvent.source.dataset.col,
      tableBodyColumn = this.instance.querySelector('.custom-table__body').querySelectorAll(`[data-col=${targetData}]`)
    tableBodyColumn.forEach((node) => {
      let cloneNode = node.cloneNode(true)
      this.draggaingTableColumn.push(cloneNode)
    })
  }

  /**
   * Save table columns order in cookie
   */

  saveColumnOrder () {
    let columnsList = []
    let nameField = this.tableId ? `orderColumns_${this.tableId}` : 'orderColumns'
    if (this.dragColumns.dataset.draggableColumns === 'save') {
      let columns = this.dragColumns.querySelectorAll('[data-col]:not(.draggable-mirror)')
      columns.forEach(node => {
        columnsList.push(node.dataset.col)
      })
      columnsList = JSON.stringify(columnsList)
      setCookie(nameField, columnsList, { expires: 432000, path: '/' })
      return false
    }
  }

  clearClasses () {
    this.instance.querySelector(this.stateClasses.dragOriginalColumn).remove()
    this.instance.querySelector(this.stateClasses.dragOverColumn).classList.remove('draggable--over')
    this.instance.querySelector(this.stateClasses.sourceDragging).classList.remove('draggable-source--is-dragging')
  }

  /**
   * add or delete additional mirror container
   */

  setDragMirror () {
    if (!document.querySelector('.custom-drag-container')) {
      let dragMirrorContainer = document.querySelector(this.stateClasses.draggingContainer),
        mirrorAdditionalContainer = document.createElement('div')

      mirrorAdditionalContainer.classList.add('custom-drag-container')
      this.draggaingTableColumn.forEach(node => {
        mirrorAdditionalContainer.appendChild(node)
      })
      dragMirrorContainer.appendChild(mirrorAdditionalContainer)
    }
  }

  init () {
    if (this.totalPriceContainer) {
      this.setDefaultTotalPrice()
    }
  }

  bindEvents () {
    $(this.instanceWrap).off('trigger::dell-item-from-cart', this.setTotalPrice, this.setRootCheckbox, this.setCheckoutBtnState)
    $(document).off('trigger::checkout', this.setAfterCheckout)

    this.instance.querySelectorAll(this.els.selectAll).forEach(rootCheckBox => {
      rootCheckBox.addEventListener('click', (e) => this.selectAllCheckBox(e))
    })

    this.itemsCheckbox.forEach(item => {
      item.addEventListener('click', (e) => {
        const { target } = { e }
        e.stopImmediatePropagation()
        this.setTotalPrice(e.target.closest('[data-item-price]'))
        this.setRootCheckbox(e)
        this.setCheckoutBtnState()
      })
    })

    if (this.checkoutBtn) {
      this.checkoutBtn.addEventListener('click', (e) => this.checkout(e))
    }

    $(this.instanceWrap).on('trigger::dell-item-from-cart', (e, label) => {
      this.checkoutItemsLength -= 1

      this.setTotalPrice(label)
      this.setRootCheckbox({ target: label }, true)
      this.setCheckoutBtnState()
    })

    $(document).on('trigger::checkout', (e, checkoutIdList) => {
      this.setAfterCheckout(checkoutIdList)
    })

    this.multiSelectOption.forEach(multiSelectOption => {
      multiSelectOption.addEventListener('click', (e) => this.displayFields(e))
    })

    if (this.draggable) {
      this.draggable.on('drag:move', () => {
        this.setDragMirror()
      })
      this.draggable.on('drag:start', (evt) => {
        this.setDraggingTableColumns(evt)
      })
      this.draggable.on('drag:stopped', () => {
        this.setDraggingTableColumns(false)
      })
      this.draggable.on('sortable:stop', (e) => {
        this.setDraggingTableColumns(false)
        this.drag(e)
        this.clearClasses()
        this.saveColumnOrder()
      })
    }
  }

}

export class TableCollection extends Collection {
  constructor () {
    super(instance, Table)

    this.init()
    this.bindEvents()
  }

  init () {
    $(instance).each((index, el) => {
      this.collection = new Table(el)
    })
  }

  bindEvents () {}
}
